export default __webpack_public_path__ + "static/media/CV_Ryan-Tennant_04-JAN-2026.74b45af8.pdf";